module.exports = __webpack_public_path__ + "img/zhu_xc2.955381b7.jpg";